var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "star_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M41.724 20.704 32 4.035l-9.723 16.669-18 5.538L16.634 38.6l-4.145 20.726L32 50.524l19.512 8.802L47.366 38.6l12.358-12.358z",
    clipRule: "evenodd"
  })));
};
export { SvgStar as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQxLjcyMzUgMjAuNzAzOEwzMi4wMDAyIDQuMDM1MjhMMjIuMjc2OSAyMC43MDM4TDQuMjc2NTggMjYuMjQyM0wxNi42MzM5IDM4LjU5OTZMMTIuNDg4NiA1OS4zMjYzTDMyLjAwMDIgNTAuNTI0MUw1MS41MTE4IDU5LjMyNjNMNDcuMzY2NCAzOC41OTk2TDU5LjcyMzcgMjYuMjQyM0w0MS43MjM1IDIwLjcwMzhaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";